class PushCartProductCard extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.data = {}
  }

  async connectedCallback () {
    super.connectedCallback()

    const propData = this.getAttribute('data-prop-data')

    if (!propData) return

    this.data = JSON.parse(propData)

    if (!this.handle) return

    this.renderInitial()
  }

  async renderInitial () {
    try {
      const response = await fetch(
        `/products/${this.handle}?section_id=push-cart-product-card`,
      )

      if (!response.ok) {
        throw new Error('Failed to fetch push cart product card section')
      }

      const text = await response.text()
      const html = new DOMParser().parseFromString(text, 'text/html')
      const sectionContent = html.querySelector(
        '#shopify-section-push-cart-product-card',
      )

      if (sectionContent) {
        this.innerHTML = sectionContent.innerHTML
        this.applyCnstrcAttributes()
      }
    } catch (error) {
      console.error('Failed to fetch push cart product card section:', error)
    }
  }

  applyCnstrcAttributes () {
    const productArticle = this.querySelector('.psh-Card')
    const titleEl = this.querySelector('.psh-Card_Title')
    const fallbackItemName = titleEl?.textContent?.trim() || ''

    if (!productArticle) {
      return
    }

    if (this.data.podId) {
      productArticle.setAttribute('data-cnstrc-item', 'recommendation')

      if (this.data.strategyId) {
        productArticle.setAttribute(
          'data-cnstrc-strategy-id',
          this.data.strategyId,
        )
      } else {
        productArticle.removeAttribute('data-cnstrc-strategy-id')
      }
    }

    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-id',
      this.data.productId,
    )
    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-name',
      this.data.itemName || fallbackItemName,
    )
    this.setCnstrcAttribute(
      productArticle,
      'data-cnstrc-item-variation-id',
      this.data.variationId,
    )
  }

  setCnstrcAttribute (element, name, value) {
    const nextValue = value || element.getAttribute(name)

    if (!nextValue) {
      element.removeAttribute(name)
      return
    }

    element.setAttribute(name, nextValue)
  }

  get handle () {
    return this.data.url?.split('products/').pop()?.split('?')[0] || ''
  }
}

if (!customElements.get('push-cart-product-card')) {
  customElements.define('push-cart-product-card', PushCartProductCard)
}
